import {EntityLocationModule} from '@entities/entity-location/entity-location.module';
import {ProductModule} from '@entities/product/product.module';
import {KhuVucModule} from '@entities/khu-vuc/khu-vuc.module';
import {NgModule} from '@angular/core';

import {AccountModule} from '@entities/account/account.module';
import {CanhTacModule} from '@entities/canh-tac/canh-tac.module';
import {ThuHoachModule} from '@entities/thu-hoach/thu-hoach.module';
import {GiongModule} from '@entities/giong/giong.module';
import {VatTuModule} from '@entities/vat-tu/vat-tu.module';
import {BaoCaoModule} from '@entities/bao-cao/bao-cao.module';
import {QrCodeModule} from '@entities/qr-code/qr-code.module';
import {TieuChuanModule} from '@entities/tieu-chuan/tieu-chuan.module';
import {ThietBiModule} from '@entities/thiet-bi/thiet-bi.module';
import {ThongSoMoiTruongModule} from '@entities/thong-so-moi-truong/thong-so-moi-truong.module';
import {NortificationModule} from '@entities/nortification/nortification.module';
import {DonViModule} from '@entities/don-vi/don-vi.module';
import {ActivityModule} from '@entities/activity/activity.module';
import {SanPhamModule} from '@entities/san-pham/san-pham.module';
import {ExampleStampModule} from '@entities/example-stamp/example-stamp.module';

@NgModule({
  imports: [
    AccountModule,
    ThuHoachModule,
    GiongModule,
    VatTuModule,
    BaoCaoModule,
    CanhTacModule,
    QrCodeModule,
    TieuChuanModule,
    ThietBiModule,
    ThongSoMoiTruongModule,
    NortificationModule,
    DonViModule,
    KhuVucModule,
    ActivityModule,
    ProductModule,
    SanPhamModule,
    EntityLocationModule,
    ExampleStampModule,
  ],
  declarations: [],
  entryComponents: [],
  providers: [],
})
export class EntityModule {}
